import {InitPage} from "../index";

declare var $;
declare var App: any;
declare const tenantCode: string;
declare const isClientHeartland: string;

export interface HeartlandProgressChannelData {
    message: string;
    progress: number;
    inProgress: boolean;
    success: boolean;
}

class HeartlandProgressUpdate {
    heartlandProgressUpdateChannel: any;

    constructor() {
        var x = (typeof tenantCode === "undefined") ? "not_available" : tenantCode;
        var isClientHeartlandd = (typeof isClientHeartland === "undefined") ? false : isClientHeartland;

        if(isClientHeartlandd == 'true'){
            this.heartlandProgressUpdateChannel = App.cable.subscriptions.create(
                {
                    channel: "Heartland::SyncProgressChannel",
                    tenant_code: x,
                    roomId: `heartland_sync_${x}`
                },
                {
                    connected() {
                        console.log("Connected to Heartland Progress Update Channel");
                    },
                    disconnected() {
                        console.log("Disconnected to Heartland Progress Update Channel");
                    },
                    received: (data: any) => this.updateProgress(data)
                }
            );
        }

    }

    updateProgress(data: HeartlandProgressChannelData) {
        console.log(data);
        $("#heartland_sync").show();
        $("#heartland_sync_btn").hide();
        $("#last_update").hide();
        $("#heartland_sync_progress").text(data.message);
        $(".progress-bar").css("width", `${data.progress}%`);
        $("#heartlandProgressLabel").text(`${data.progress}%`);
        $(".currentStatusDesc_Category").text(`${data.message}`);
        var bat = $(".categ_hl_sync").length == 1
        if (!data.inProgress && data.success && bat){
            $(".progress-spin").hide();
            $(".fail-img").hide();
            $(".doSyncBtn").hide();
            $(".heartlandSyncBtn").show();
            $(".heartlandSyncBtn").removeAttr('disabled')
            $(".previewSyncBtn").removeAttr('disabled')
            $('.success-img').removeClass("hide");
            $('.success-img').show();
            $(".currentStatusDesc_Category").text('Synchronization preview complete')
        }
        if (!data.inProgress && data.success && !bat) {
            this.refresh();
            $("#heartland_sync_btn").show();
            $("#last_update").show();
        }
        if (!data.success) {
            this.refresh();
        }
    }

    refresh(): void {
        window.location.reload();
    }
}

export function LoadPage() {
    InitPage("items", () => {
        const ts = new HeartlandProgressUpdate();
    });
    InitPage("compare_v2", () => {
        const t = new HeartlandProgressUpdate();
    });
    InitPage("print_v2", () => {
        const t = new HeartlandProgressUpdate();
    });
}
